import jsSHA from "jssha";

export function anonymizeString(value: string): string {
    const sha = new jsSHA("SHA-1", "TEXT", { encoding: "UTF8" });
    sha.update(value);
    return sha.getHash("HEX");
}
